export default __webpack_public_path__ + "static/media/gammaInfinity.6190939a.svg";